package com.eladfinish.bible.contest.analytics.crashlytics

import io.github.aakira.napier.Napier

expect fun recordCrashlyticsException(throwable: Throwable)
expect fun setCrashlyticsUserIdPlatform(userId: String)
expect fun setCrashlyticsCustomKeyPlatform(key: String, value: String)

object AppCrashlytics {
    fun logException(throwable: Throwable?) {
        Napier.e(throwable = throwable, message = "AppCrashlytics")
        throwable?.let {
            recordCrashlyticsException(it)
        }
    }
}
